import { EN_PAGE_NAME, getMetaTemplate } from './metaData';

export const commonTitle = 'NOL';
export const commonKeyWords = [
  '놀',
  'nol',
  '야놀자',
  'yanolja',
  '여행',
  '호텔',
  '리조트',
  '펜션',
  '풀빌라',
  '모텔',
  '레지던스',
  '캠핑',
  '글램핑',
  '게스트하우스',
  '레지던스',
  '스파',
  '반려동물 동반 숙소',
  '키즈 펜션',
  '호캉스',
  '카라반',
  '레저',
  '액티비티',
  '워터파크',
  '롯데월드',
  '에버랜드',
  '캐리비안베이',
  '대구이월드스카이드롭',
  '아쿠아리움',
  '주말나들이',
  '키즈풀빌라',
  '가평풀빌라',
  '서울호캉스',
  '제주도 호텔',
  '해외여행',
  '항공권',
  '일본',
  '베트남',
  '홍콩',
  '태국',
  '후쿠오카',
  '오사카',
  '나트랑',
  '도쿄',
  '다낭',
  '방콕',
];

export interface IOpenGraphMeta {
  'og:title': string;
  'og:image': string | undefined;
  'og:description': string;
  'og:type': 'website';
}

export interface ITwitterMeta {
  'twitter:card': 'summary';
  'twitter:title': string;
  'twitter:description': string;
}

export interface IMetaInfo {
  title?: string;
  description?: string;
  pageUrl?: string;
  pageName?: EN_PAGE_NAME;
  options?: {
    [key: string]: string | number | undefined;
    image?: string;
  };
}

export interface IPageMeta {
  title: string;
  description: string;
  canonical?: string;
  tagKeywords: string;
  openGraph: IOpenGraphMeta;
  twitter: ITwitterMeta;
}

const addTitle = (title: string) => (str: string): string => str.concat(` | ${title}`);

/**
 * Page 컴포넌트에 사용할 메타 태그용 props를 생성한다
 * 기본적으로 하는 역할은 주요 정보를 함수로 넘겨서 공통 문장 등을 삽입해주고
 * pageUrl의 경우에는 쿼리스트링을 제거하여 canonical 태그로 사용할 수 있도록 만든다
 * tagKeywords의 경우 정책이 아직 확정되지 않아 기존 PC웹 프로젝트의 공통 태그를 삽입한다
 * PC 버전의 내용을 참고하려면 yanolja-web/src/client/common/head/core/metas.js 참고
 *
 * @param title
 * @param description
 * @param pageUrl
 * @param pageName
 */
export function generatePageMeta({ title, description, pageUrl, pageName, options = {} }: IMetaInfo = {}): IPageMeta {
  const addCommonTitle = addTitle(commonTitle);
  const pageMetaTemplate = getMetaTemplate(pageName);

  let metaTitle: string;
  let metaDesc: string;
  let metaTagKeywords: string;
  let metaImageUrl: string;

  if (title) {
    metaTitle = addCommonTitle(title);
  } else if (pageMetaTemplate.title) {
    metaTitle = pageMetaTemplate.title(options);
  } else {
    metaTitle = commonTitle;
  }
  metaTitle = metaTitle.trim();

  if (description) {
    metaDesc = addCommonTitle(description);
  } else if (pageMetaTemplate.description) {
    metaDesc = pageMetaTemplate.description(options);
  } else {
    metaDesc = '';
  }
  metaDesc = metaDesc.trim();

  if (pageMetaTemplate.tagKeywords) {
    metaTagKeywords = pageMetaTemplate.tagKeywords(options);
  } else {
    metaTagKeywords = commonKeyWords.join(', ');
  }

  if (options.image) {
    metaImageUrl = options.image.replace('http://', 'https://');
  } else {
    metaImageUrl = 'https://yaimg.yanolja.com/joy/sunny/static/images/nol/nol_og_1200x600.png';
  }

  return {
    title: metaTitle,
    description: metaDesc,
    tagKeywords: metaTagKeywords,
    canonical: pageUrl,
    openGraph: {
      'og:title': metaTitle,
      'og:image': options.image === ' ' ? '' : metaImageUrl,
      'og:description': metaDesc,
      'og:type': 'website',
    },
    twitter: {
      'twitter:card': 'summary',
      'twitter:title': metaTitle,
      'twitter:description': metaDesc,
    },
  };
}
